import React, { useContext } from "react";
import StateButtonDisplayImage from "./images/StateButtonDisplayImage.png";
import { DashboardContext } from "../../workspace_components/TenantAdministratorComponents/Dashboards/DashboardProvider";
const ButtonsWidgets = ({ selectedWidgetBundle, setSelectedWidgetBundle}) =>{
    const { setShowWidgetsLibrary,setSelectedNewWidgetWindow } = useContext(DashboardContext);
        if(selectedWidgetBundle !== 'buttons') return null;
        return (
            <div className="widgets-library-container" style={{zIndex:"10"}}>
                <div className="widgets-library-header-container">
                    <div style={{display:"flex",alignItems:"center"}}>
                        <p
                            style={{fontWeight:"bold",fontSize:"25px",marginRight:"10px"}}
                            onClick={() => setSelectedWidgetBundle('')}
                        >&#8592;</p>
                        <h3>Buttons: Select widget</h3>
                    </div>
                    <p onClick={() =>{
                        setSelectedWidgetBundle('');
                        setShowWidgetsLibrary(false);
                    }}>&#10006;</p>
                </div>
                <div className="widgets-library-body-container">
                    <div className="widgets-library-grid">
                        <div className="widgets-bundle-container"
                        onClick={() =>{
                            setSelectedWidgetBundle('');
                            setShowWidgetsLibrary(false);
                            setSelectedNewWidgetWindow('state_navigation_button');
                        }}>
                            <h4>State navigation button</h4>
                            <img src={StateButtonDisplayImage} alt="Button" style={{height:'120px'}} />
                        </div>
                    </div>
                </div>
            </div>
        )
};
export default ButtonsWidgets;